const getOrderLineModel = ({ orderLine, value, index }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  if (index !== undefined) {
    const indexOrderLine = orderLine ? orderLine[index] : null;
    return indexOrderLine && indexOrderLine.Product ? indexOrderLine.Product.Model : null;
  }
  return orderLine
    ? orderLine.map(item => item.Product.Model).join(', ')
    : null;
};

export default getOrderLineModel;



// WEBPACK FOOTER //
// ./src/utils/print/getOrderLineModel.js